export const SEARCH_DEBOUNCE_INTERVAL = 500;

export const TEST_ID = {
  contentHubViewer: 'contentHubViewer',
};
